import paper from 'paper'

export default class HalfQuartArc {
  constructor(insertMaterial, handleWidth, handleType) {
    this.path
    this.insertMaterial = insertMaterial
    this.handleType = handleType

    this.pocketSpacing = 19
    this.shadowOffset = 1.5
    this.insetX = 35
    this.insetY = -this.shadowOffset

    switch (this.handleType) {
      case 'lrgHalfArc':
      case 'halfArc':
        this.handleRad = handleWidth / 2 + this.pocketSpacing
        this.width = this.handleRad * 2
        this.height = this.handleRad
        break
      case 'lrgQuartArc':
      case 'quartArc':
        this.handleRad = handleWidth + this.pocketSpacing
        this.width = this.handleRad
        this.height = this.handleRad
        break
    }

    this.draw()
  }

  draw() {
    // Create circle centered at origin (like production version)
    let circle = new paper.Path.Circle({
      center: [0, 0],
      radius: this.handleRad
    })

    circle.fillColor = this.insertMaterial ? this.insertMaterial.uiColour : '#FF0000'
    circle.strokeColor = 'black'

    if (this.handleType === 'halfArc' || this.handleType === 'lrgHalfArc') {
      // Subtract top half to keep bottom semicircle
      let subtractRec = new paper.Path.Rectangle(
        new paper.Point(-this.handleRad, -this.handleRad),
        new paper.Size(this.handleRad * 2, this.handleRad - this.shadowOffset)
      )
      this.path = circle.subtract(subtractRec)
      subtractRec.remove()
    } else if (this.handleType === 'quartArc' || this.handleType === 'lrgQuartArc') {
      // Subtract left and top to keep bottom-right quarter
      let subtractLeft = new paper.Path.Rectangle(
        new paper.Point(-this.handleRad, -this.handleRad),
        new paper.Size(this.handleRad - this.shadowOffset, this.handleRad * 2)
      )
      let subtractTop = new paper.Path.Rectangle(
        new paper.Point(-this.handleRad, -this.handleRad),
        new paper.Size(this.handleRad * 2, this.handleRad - this.shadowOffset)
      )
      let subtractPath = subtractLeft.unite(subtractTop)
      this.path = circle.subtract(subtractPath)

      subtractLeft.remove()
      subtractTop.remove()
      subtractPath.remove()
    }

    circle.remove()
  }
}
